import { useTranslation } from 'react-i18next';
import { CreditCard } from '@parrot-software/design-system/icons';

import { PaymentMethodCard } from './PaymentMethodCard';

/** Stable RadioGroup value identifying the credit/debit card payment method. */
export const CARD_PAYMENT_METHOD_VALUE = 'CARD';

type CardPaymentMethodCardProps = {
  disabled?: boolean;
  isSelected: boolean;
};

/**
 * Credit/debit card payment-method card.
 *
 * Owns the icon and copy for the card option and renders them through the
 * generic `PaymentMethodCard` wrapper. The body explains that paying by card
 * enables an automated payment and immediate invoicing (single i18n key).
 * Renders disabled when the block requires advance invoicing (card is not a
 * valid method in that case — SPEI is the only option).
 *
 * @param props - Component properties
 * @returns React element rendering the card payment-method card
 */
export const CardPaymentMethodCard = ({ disabled = false, isSelected }: CardPaymentMethodCardProps) => {
  const { t } = useTranslation('subscriptions');

  return (
    <PaymentMethodCard
      disabled={disabled}
      icon={<CreditCard aria-hidden className="h-6 w-6 text-foreground" />}
      isSelected={isSelected}
      title={t('paymentMethod.creditOrDebit')}
      value={CARD_PAYMENT_METHOD_VALUE}
    >
      <p className="whitespace-pre-line text-sm font-normal leading-5 text-muted-foreground">
        {t('blockCreationWizard.payment.card.body')}
      </p>
    </PaymentMethodCard>
  );
};
